var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFigSkate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictogram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.7,
    cy: 37.3,
    rx: 9,
    ry: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.7,51.4h-33.5L73.8,25c-2-2-5.3-2-7.3,0s-2,5.3,0,7.3l19.2,19.2H64.3v18h32.1c2.3,0,4.6-0.9,6.4-2.6 c1.4-1.4,2.3-3.2,2.5-5.1h28.3c2.8,0,5.1-2.3,5.1-5.1C138.9,53.7,136.6,51.4,133.7,51.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4,131.1c2.8,0,5.1-2.3,5.1-5.1V72H64.3v54C64.3,128.8,66.6,131.1,69.4,131.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,16.3c-2-2-5.3-2-7.3,0s-2,5.3,0,7.3L59.1,66V51.4L24,16.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.7,
    y: 133.6,
    width: 20.6,
    height: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.9,
    y: 14.1,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -7.3487 13.1752)",
    width: 20.6,
    height: 2.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigSkate);
export default __webpack_public_path__ + "static/media/figSkate.c9285bc58c5aaf606814c74fa935a75a.svg";
export { ForwardRef as ReactComponent };